import { Link as RouterLink } from "react-router";
import MUIButton from "@mui/material/Button";

import { isInternalHref } from "shared/utils";

import { Props } from "./types";

const Button = ({
  children,
  testId,
  label,
  href,
  replace,
  ...otherProps
}: Props) => {
  const content = children ? children : label;

  if (href && isInternalHref(href)) {
    return (
      <MUIButton
        component={RouterLink}
        to={href}
        replace={replace}
        data-testid={testId}
        {...otherProps}
        loadingPosition="start"
      >
        {content}
      </MUIButton>
    );
  }

  return (
    <MUIButton
      href={href}
      data-testid={testId}
      {...otherProps}
      loadingPosition="start"
    >
      {content}
    </MUIButton>
  );
};

export default Button;
